import { RuleConfigAdvancedParameterModel } from "../../../../../../models/customers/customer.models";

export class DateRangeValueConverter {
    fromView(value: string, item: {type: string, item:RuleConfigAdvancedParameterModel}) {
        if (item.type == 'date') {
            const day = this.toView(item.item.value, {type: "day", item:item.item});
            return day ? `${day} - ${value}` : ` - ${value}`;
        }

        if (item.type == 'day') {
            const date = this.toView(item.item.value,{type: "date", item:item.item});
            return date ? `${value} - ${date}` : value;
        }

        return "";
    }

    toView(value: string, item: {type: string, item:RuleConfigAdvancedParameterModel}) {
        if (value) {
            if (item.type == 'date') {
                const s = value.toString().split(" - ");
                return s.length > 1 ? s[1] : "";
            }

            if (item.type == 'day') {
                const s = value.toString().split(" - ");
                return s.length > 0 ? s[0] : "today";
            }
        }

        return "";
    }
}